import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { GifPreview } from "@teammood/timeline";

@Component({
    selector: 'tm-gif-preview',
    templateUrl: './gifpreview.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: []
})
export class GifPreviewComponent {
    @Input() gifPreview: GifPreview;

}